import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {DefaultFormComponentConfig} from '@vendure/common/lib/shared-types';

import {DataService, FormInputComponent, ModalService} from '@vendure/admin-ui/core';
import {ProductMultiSelectorDialogComponent} from '../product-multi-selector-dialog/product-multi-selector-dialog.component';
// import {ProductMultiSelectorDialogComponent} from '@vendure/admin-ui/core';

@Component({
  selector: 'app-product-multi-selector-form-input',
  templateUrl: './product-multi-selector-form-input.component.html',
  styleUrls: ['./product-multi-selector-form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductMultiSelectorFormInputComponent implements OnInit, FormInputComponent {
  @Input() config: DefaultFormComponentConfig<'product-multi-form-input'>;
  @Input() formControl: FormControl;
  @Input() readonly: boolean;
  mode: 'product' | 'variant' = 'product';
  readonly isListInput = true;
  static readonly id = 'custom-product-multi-form-input';

  constructor(
    private modalService: ModalService,
    private dataService: DataService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.mode = this.config.ui?.selectionMode ?? 'product';
  }

  select() {
    this.modalService
      .fromComponent(ProductMultiSelectorDialogComponent, {
        size: 'xl',
        locals: {
          mode: this.mode,
          initialSelectionIds: this.formControl.value,
        },
      })
      .subscribe(selection => {
        if (selection) {
          this.formControl.setValue(
            selection.map(item => (this.mode === 'product' ? item.productId : item.productVariantId)),
          );
          this.changeDetector.markForCheck();
        }
      });
  }
}
